import createElementChangeListener from "../../elementChangeListener";
import curry from "../../lib/core/functional/curry";
import makeTransportContext from "../../utils/makeTransportContext";
import { dispatchNextPage } from "../../transport/nextPage";

import { hasMoreContent, renderLoaded, calculateLoadingHeight } from "./_common";

const onNextPageLoadedAfterClick = curry(function onNextPageLoadedAfterClick(
    currentTarget,
    placeholder,
    button,
    [data, _pageNumber]
) {
    const node = renderLoaded(placeholder, data, true);
    placeholder.classList.remove("rm-loading");
    placeholder.style.minHeight = "0px";
    if (!hasMoreContent(node, data.posts_html)) {
        button.classList.add("hidden");
    }
    currentTarget.innerText = currentTarget.dataset.previousText;
});

function setUpPlaceholder(currentTarget) {
    const placeholder = document.createElement("div");
    placeholder.className = "rm-loadmore-placeholder rm-loading";
    const loadingHeight = calculateLoadingHeight(currentTarget.parentElement);
    placeholder.style.minHeight = `${loadingHeight}px`;
    currentTarget.parentElement.insertBefore(placeholder, currentTarget);
    return placeholder;
}

const onLoadMoreClick = curry(function onLoadMoreClick(context, button, event) {
    const { currentTarget } = event;
    currentTarget.dataset.previousText = currentTarget.innerText;
    currentTarget.innerText = button.dataset.loadingText || "Loading";
    const placeholder = setUpPlaceholder(currentTarget);
    dispatchNextPage(makeTransportContext(currentTarget, context)).then(
        onNextPageLoadedAfterClick(currentTarget, placeholder, button)
    );
});

const setupButton = curry(function setupButton(context, button) {
    if ("hasMore" in button.dataset && button.dataset.hasMore !== "true") {
        return;
    }

    if ("morePostsExists" in button.dataset && button.dataset.morePostsExists !== "true") {
        return;
    }

    button.classList.remove("hidden");
    button.addEventListener("click", onLoadMoreClick(context, button));
});

export default function setupButtonLoadPage(context) {
    createElementChangeListener(".button-load-more", setupButton(context));
    return context;
}
